import { render } from "./ListeMandature.vue?vue&type=template&id=bb57434c&ts=true"
import script from "./ListeMandature.vue?vue&type=script&lang=ts"
export * from "./ListeMandature.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__